import useSpin from './useSpin';

const Mun = ({ className, style }) => {
  const { svgRef, rotation, isDragging, handleMouseDown, handleTouchStart } =
    useSpin();

  return (
    <svg
      ref={svgRef}
      viewBox='90 90 320 320'
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id='gradient' gradientTransform='rotate(90)'>
          <stop offset='0%' stopColor='var(--mun-color-start)' />
          <stop offset='100%' stopColor='var(--mun-color-stop)' />
        </linearGradient>
      </defs>
      <g
        style={{
          cursor: isDragging ? 'grabbing' : 'grab',
          userSelect: 'none',
          touchAction: 'none',
        }}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
      >
        <g
          style={{
            transform: `rotate(${rotation}deg)`,
            transformOrigin: '249.6px 250px',
          }}
        >
          <circle
            style={{
              fill: 'var(--mun-color)',
            }}
            cx='249.6'
            cy='250'
            r='160'
          />
          <g>
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='138.4'
              cy='165.2'
              r='9.6'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='124.8'
              cy='201.2'
              r='1.6'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='189.6'
              cy='222'
              r='29.6'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='202.4'
              cy='157.2'
              r='8'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='257.6'
              cy='153.2'
              r='2.4'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='278.4'
              cy='126'
              r='2.4'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='201.6'
              cy='127.6'
              r='4'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='233.6'
              cy='114'
              r='1.6'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='270.4'
              cy='206'
              r='6.4'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='318.4'
              cy='202'
              r='4'
            />
          </g>
          <circle
            style={{ fill: 'var(--mun-spot-color)' }}
            cx='328.8'
            cy='156.4'
            r='6.4'
          />
          <g>
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='300.8'
              cy='285.2'
              r='17.6'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='156'
              cy='295.6'
              r='5.6'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='213.6'
              cy='271.6'
              r='2.4'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='241.6'
              cy='331.6'
              r='9.6'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='124.8'
              cy='254.8'
              r='6.4'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='267.2'
              cy='250.8'
              r='1.6'
            />
          </g>
          <circle
            style={{ fill: 'var(--mun-spot-color)' }}
            cx='344'
            cy='254'
            r='4'
          />
          <g>
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='174.4'
              cy='339.6'
              r='9.6'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='193.6'
              cy='305.2'
              r='3.2'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='292.8'
              cy='342.8'
              r='3.2'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='241.6'
              cy='369.2'
              r='2.4'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='201.6'
              cy='365.2'
              r='1.6'
            />
          </g>
          <circle
            style={{ fill: 'var(--mun-spot-color)' }}
            cx='332.8'
            cy='328.4'
            r='6.4'
          />
          <g>
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='284'
              cy='375.6'
              r='4'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='245.6'
              cy='289.2'
              r='3.2'
            />
          </g>
          <circle
            style={{ fill: 'var(--mun-spot-color)' }}
            cx='353.6'
            cy='300.4'
            r='6.4'
          />
          <g>
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='134.4'
              cy='323.6'
              r='5.6'
            />
            <circle
              style={{ fill: 'var(--mun-spot-color)' }}
              cx='309.6'
              cy='241.2'
              r='7.2'
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Mun;
